export default __webpack_public_path__ + "static/5-e7b9a7b5fdf677e3f88c03afba0749be.png";